<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    const _env = process.env.NODE_ENV;
    const disabledLog = !process.env.VUE_APP_CONSOLE_LOG;
    console.log("_env", _env, disabledLog);

    if ((_env === "production" && disabledLog) || disabledLog) {
      // Disable console log // on production
      console.log = function () {};
    }

    console.log("check console log");
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  mounted() {
    this.setDocumentTitle();
  },
  data() {
    return {
      token: localStorage.getItem("access_token"),
      suffixTitle: "Beauty Connect Admin",
    };
  },
  methods: {
    setDocumentTitle(route = this.$route) {
      document.title = route.meta?.title ? `${route.meta.title} - ${this.suffixTitle}` : this.suffixTitle;
    }
  },
  watch:{
    $route() {
      this.setDocumentTitle();
    }
  },
};
</script>
